import { render, staticRenderFns } from "./AgentNotifications.vue?vue&type=template&id=5454d213&scoped=true"
import script from "./AgentNotifications.vue?vue&type=script&lang=ts"
export * from "./AgentNotifications.vue?vue&type=script&lang=ts"
import style0 from "./AgentNotifications.vue?vue&type=style&index=0&id=5454d213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454d213",
  null
  
)

export default component.exports